import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './WarningText.module.scss';
import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

const WarningText = ({ message, variant, bold, ...props }) => {
    const iconClasses = ['govuk-warning-text__icon'];
    if (variant === 'triangle') {
        iconClasses.push(styles.warningIconTriangle);
    }

    let label = '!';
    if (variant === 'triangle') {
        label = '';
    }

    const textClasses = ['govuk-warning-text__text', styles.warningText];
    if (!bold) {
        textClasses.push(styles.notBold);
    }

    return (

        <div className="govuk-warning-text" {...props}>
            <span className={iconClasses.join(' ')} aria-hidden="true">{label}</span>
            <strong className={textClasses.join(' ')}>
                <span className="govuk-visually-hidden">
                    <FormattedMessage id="warningText.warning" />
                </span>
                {message}
            </strong>
        </div>
    );
};

WarningText.propTypes = {
    message: PropTypes.node,
    variant: PropTypes.oneOf(['triangle', 'circle', 'exclamation']),
    bold: PropTypes.bool,
    ...defaultAriaProps
};

WarningText.defaultProps = {
    variant: 'triangle',
    bold: true
};

export default WarningText;
